(function() {
  /** @type {WeakMap<HTMLElement, any>} */
  const initializedCarousels = new WeakMap();

  /**
   * @param {HTMLElement} carouselElement
   */
  function initCarousel(carouselElement) {
    if (!carouselElement) return;
    
    // Skip if already initialized
    if (initializedCarousels.has(carouselElement)) return;

    if (typeof EmblaCarousel === 'undefined') {
      setTimeout(() => initCarousel(carouselElement), 100);
      return;
    }

    const embla = EmblaCarousel(carouselElement, {
      loop: false,
      align: 'start',
      containScroll: 'trimSnaps',
      slidesToScroll: 1,
      dragFree: false
    });

    initializedCarousels.set(carouselElement, embla);

    const prevButton = /** @type {HTMLButtonElement | null} */ (carouselElement.closest('.nf-grid-slider__carousel')?.querySelector('.nf-grid-slider__button--prev'));
    const nextButton = /** @type {HTMLButtonElement | null} */ (carouselElement.closest('.nf-grid-slider__carousel')?.querySelector('.nf-grid-slider__button--next'));
    const dotsContainer = carouselElement.closest('.nf-grid-slider__carousel')?.querySelector('.nf-grid-slider__dots');
    const slides = carouselElement.querySelectorAll('.nf-grid-slider__slide');

    const setupDots = () => {
      if (!dotsContainer) return;
      
      dotsContainer.innerHTML = '';
      slides.forEach((/** @type {Element} */ _, /** @type {number} */ index) => {
        const dot = document.createElement('button');
        dot.className = 'nf-grid-slider__dot';
        dot.setAttribute('type', 'button');
        dot.setAttribute('aria-label', `Go to slide ${index + 1}`);
        dot.addEventListener('click', () => embla.scrollTo(index));
        dotsContainer.appendChild(dot);
      });
    };

    const updateDots = () => {
      const selectedIndex = embla.selectedScrollSnap();
      const dots = dotsContainer?.querySelectorAll('.nf-grid-slider__dot');
      dots?.forEach((/** @type {Element} */ dot, /** @type {number} */ index) => {
        if (index === selectedIndex) {
          dot.classList.add('nf-grid-slider__dot--active');
        } else {
          dot.classList.remove('nf-grid-slider__dot--active');
        }
      });
    };

    const updateSlides = () => {
      const selectedIndex = embla.selectedScrollSnap();
      slides.forEach((/** @type {Element} */ slide, /** @type {number} */ index) => {
        if (index === selectedIndex) {
          slide.classList.add('nf-grid-slider__slide--active');
        } else {
          slide.classList.remove('nf-grid-slider__slide--active');
        }
      });
    };

    const updateButtons = () => {
      if (prevButton) {
        prevButton.disabled = !embla.canScrollPrev();
      }
      if (nextButton) {
        nextButton.disabled = !embla.canScrollNext();
      }
    };

    if (prevButton) {
      prevButton.addEventListener('click', () => embla.scrollPrev());
    }

    if (nextButton) {
      nextButton.addEventListener('click', () => embla.scrollNext());
    }

    embla.on('select', () => {
      updateDots();
      updateButtons();
      updateSlides();
    });

    embla.on('init', () => {
      setupDots();
      updateDots();
      updateButtons();
      updateSlides();
    });

    setupDots();
    updateDots();
    updateButtons();
    updateSlides();
  }

  function initAllCarousels() {
    const carousels = document.querySelectorAll('.nf-grid-slider__viewport:not([data-initialized])');
    carousels.forEach((/** @type {Element} */ carousel) => {
      if (carousel instanceof HTMLElement) {
        carousel.setAttribute('data-initialized', 'true');
        initCarousel(carousel);
      }
    });
  }

  function handleThemeEditorUpdates() {
    // Listen for theme editor DOM updates
    if (window.Shopify?.designMode) {
      document.addEventListener('shopify:section:load', initAllCarousels);
      document.addEventListener('shopify:section:reorder', initAllCarousels);
      document.addEventListener('shopify:block:select', initAllCarousels);
    }
  }

  // Initial load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initAllCarousels();
      handleThemeEditorUpdates();
    });
  } else {
    initAllCarousels();
    handleThemeEditorUpdates();
  }

  // Use MutationObserver for theme editor updates
  if (window.Shopify?.designMode) {
    const observer = new MutationObserver(() => {
      initAllCarousels();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
})();

